import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { v4 } from 'uuid';
import { environment } from '../../environments/environment';
import { BookerPlannerBffApiClient } from './bff-api-clients/booker-planner-bff-api-client';

@Injectable({
    providedIn: 'root',
})
export class BffApiService {
    private httpClient = inject(HttpClient);
    public bffClient: BookerPlannerBffApiClient;

    constructor() {
        this.lockBrowserTab();
        this.bffClient = new BookerPlannerBffApiClient(this.httpClient, environment.bffApiUrl);
    }

    private lockBrowserTab(): void {
        const navHack = window.navigator;

        if (navHack && navHack.locks && navHack.locks.request) {
            const uniqueTabName = 'RaxBooker_tab_' + v4();
            const promise = new Promise(() => {
                console.log('Lock tab ' + uniqueTabName);
            });

            navHack.locks.request(uniqueTabName, { mode: 'shared' }, () => {
                return promise;
            });
        }
    }
}
